import { Card, Select } from "antd";
import SelectDropdownLgIcon from "../../../../../assets/icons/SelectDropdownLgIcon";

interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateDropdown({ data }: Props) {
  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch justify-start text-zinc-700 text-base font-medium">
          {data?.question_title}
        </div>
        <div className="mt-4">
          <Select
            className="min-w-[300px]"
            placeholder="Choose an option"
            size="large"
            allowClear
            showSearch
            suffixIcon={<SelectDropdownLgIcon />}
            value={data?.answer || undefined}
            options={
              data?.question_choices?.map((choice: any) => ({
                value: choice,
                label: choice,
              })) || []
            }
          />
        </div>
      </Card>
    </>
  );
}
